//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'App',

  computed: {
    ...mapGetters('cache', ['aliveComponents']),
    cacheComponents () {
      return this.aliveComponents || []
    },
  },

  watch: {
    '$route': {
      handler (to, from) {
        const list = [
          'crEnrollResult',
          'qtEnrollResult',
          'qtGardeSearch',
        ]
        const fullScreen = list.findIndex((val) => location.href.indexOf(val) >= 0) >= 0

        if (fullScreen) {
          document.body.style.width = '100%'
        }
      },
      immediate: true,
    },
  },
}
